/**
 * Pads zeros to the left until required length
 *
 * String can be trimmed if length is lower actual one
 *
 * @param {String} value
 * @param {Number} length
 * @returns {*}
 */
export default function padZeroEnd(value: string, length: number): string {
  const doLength = length >= 0 ? length : value.length;

  if (!doLength) {
    return '';
  }

  return `${value}000000000`.substr(0, doLength);
}
